import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Popover,
  Select,
  Stack,
} from '@mui/material';
import React from 'react';
import { Button } from 'src/components/atoms';
import * as styles from './CustomFields.styles';
import { CustomFieldFilters } from './customFields.types';

const STATUS_FILTER_OPTIONS = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Retired' },
];

const TYPE_FILTER_OPTIONS = [
  { value: 'TEXT', label: 'Text input' },
  { value: 'SINGLE_SELECT', label: 'Single select' },
];

export interface CustomFieldsFilterPopoverProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  value: CustomFieldFilters;
  onChange: (value: CustomFieldFilters) => void;
}

export const CustomFieldsFilterPopover: React.FC<
  CustomFieldsFilterPopoverProps
> = ({ anchorEl, open, onClose, value, onChange }) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
  >
    <Stack sx={styles.filterPopover} data-testid="custom-fields-filter-popover">
      <FormControl size="medium">
        <InputLabel id="custom-fields-status-filter-label">Status</InputLabel>
        <Select<string>
          labelId="custom-fields-status-filter-label"
          label="Status"
          value={value.status}
          data-testid="custom-fields-status-filter"
          onChange={(e) => onChange({ ...value, status: e.target.value })}
        >
          {STATUS_FILTER_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="medium">
        <InputLabel id="custom-fields-type-filter-label">Type</InputLabel>
        <Select<string>
          labelId="custom-fields-type-filter-label"
          label="Type"
          value={value.type}
          data-testid="custom-fields-type-filter"
          onChange={(e) => onChange({ ...value, type: e.target.value })}
        >
          {TYPE_FILTER_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box sx={styles.filterPopoverActions}>
        <Button
          variant="tertiary"
          data-testid="custom-fields-filter-clear"
          onClick={() => onChange({ status: '', type: '' })}
        >
          Clear
        </Button>
      </Box>
    </Stack>
  </Popover>
);
